import type { RouteRecordRaw } from 'vue-router'
import CoacheesPage from '../../modules/coachees/pages/CoacheesPage.vue'
import AddCoacheesPage from '../../modules/coachees/pages/AddCoacheesPage.vue'
import CoachOnboardingPage from '../../modules/coachees/pages/CoachOnboardingPage.vue'
import CoacheePage from '../../modules/coachees/pages/CoacheePage.vue'
import CoacheePassedDialogsPage from '../../modules/coachees/pages/CoacheeFinishedDialogsPage.vue'
import CoacheeArchivedObjectivesPage from '../../modules/coachees/pages/CoacheeArchivedObjectivesPage.vue'
import CoachSurveysPage from '../../modules/coach-surveys/pages/CoachSurveysPage.vue'
import CoachSurveyPage from '../../modules/coach-surveys/pages/CoachSurveyPage.vue'
import CoachFeedbackGoalsPage from '../../modules/coach-feedback-goals/pages/CoachFeedbackGoalsPage.vue'
import CoachFeedbackGoalPage from '../../modules/coach-feedback-goals/pages/CoachFeedbackGoalPage.vue'
import AssessmentsPage from '../../modules/assessment/pages/AssessmentsPage.vue'
import AssesmentPage from '../../modules/assessment/pages/AssesmentPage.vue'
import PrintCoacheeProfilePage from '@/modules/coachees/pages/PrintCoacheeProfilePage.vue'

export const coachingRoutes: RouteRecordRaw[] = [
  {
    path: '/add-coachees',
    name: 'add-coachees',
    component: AddCoacheesPage,
    meta: {
      layout: 'full-screen',
    },
  },
  {
    path: '/coach-onboarding',
    name: 'coach-onboarding',
    component: CoachOnboardingPage,
    meta: {
      layout: 'full-screen',
    },
  },
  {
    path: '/coach/surveys',
    name: 'coach-surveys',
    component: CoachSurveysPage,
  },
  {
    path: '/coach/surveys/:id',
    name: 'coach-survey',
    component: CoachSurveyPage,
  },
  {
    path: '/coach/assessments',
    name: 'assessments',
    component: AssessmentsPage,
  },
  {
    path: '/coach/assessments/:surveyTemplateId',
    name: 'assessment',
    component: AssesmentPage,
  },
  {
    path: '/coach/feedback-goals',
    name: 'coach-feedback-goals',
    component: CoachFeedbackGoalsPage,
  },
  {
    path: '/coach/feedback-goals/:feedbackGoalId',
    name: 'coach-feedback-goal',
    component: CoachFeedbackGoalPage,
  },
  {
    path: '/coachees',
    name: 'coachees',
    component: CoacheesPage,
  },
  {
    path: '/coachee/:coacheeId/dialogs',
    name: 'coachee-dialogs',
    component: CoacheePassedDialogsPage,
  },
  {
    path: '/coachee/:id/objectives/archived',
    name: 'coachee-archived-objectives',
    component: CoacheeArchivedObjectivesPage,
  },
  {
    path: '/coachee/:id',
    name: 'coachee',
    component: CoacheePage,
  },
  {
    path: '/print-coachee-profile',
    name: 'print-coachee-profile',
    component: PrintCoacheeProfilePage,
    meta: {
      layout: 'print',
      isPublic: true,
    },
  },
]
